import React, { useState, useContext, useRef, useEffect } from 'react'
import { BuilderContext } from '../../pages/Sandbox/components/store/store.Builder'

import styles from './EditableLabel.module.css'

const EditableLabel = ({ field }) => {
  const builderContext = useContext(BuilderContext)
  const [isEditing, setIsEditing] = useState(false)
  const divRef = useRef()

  const label_style = field.label_design ? { ...field.label_design } : {}

  useEffect(() => {
    if (isEditing) {
      divRef.current.focus()
    }
  }, [isEditing])

  const handleLabelChange = () => {
    const updatedField = {
      ...field,
      label: divRef.current.textContent,
      typeSelected: 'field',
    }
    builderContext.handleFieldUpdate(updatedField, true)
    // builderContext.handleEditButtonClick(updatedField)
  }

  const handleDoubleClick = (event) => {
    setIsEditing(true)
    builderContext.setEditingText(true)
  }

  const handleClick = (event) => {
    if (event.target !== event.currentTarget) {
      return
    }
    console.log('Clic dans le label')
    try {
      builderContext.setSelectedField(
        { design: field.label_design, id: field.id },
        'label'
      )
    } catch (error) {
      console.error(
        'Error in EditableLabel in setSelectedField:',
        error.message
      )
    }
  }

  const label =
    builderContext.fields.find((item) => item.id === field.id)?.label ||
    field.label

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div className={styles.required}>{field.required && '*'}</div>
      <div
        ref={divRef}
        style={label_style}
        className={`${styles.label} ${
          builderContext.selectedField?.id === field.id &&
          builderContext.selectedField?.typeSelected === 'label'
            ? 'selected__item'
            : ''
        }`}
        contentEditable={isEditing}
        onBlur={() => {
          setIsEditing(false)
          builderContext.setEditingText(false)
          handleLabelChange()
          builderContext.setIsBarButtonVisible(true)
        }}
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
        suppressContentEditableWarning={true}
      >
        {label}
      </div>
    </div>
  )
}

export default EditableLabel
